import t from "./SwitchButtonGroup.vue2.mjs";
import { resolveComponent as n, openBlock as s, createBlock as a, normalizeClass as d, withCtx as p, renderSlot as m } from "vue";
import u from "../../_virtual/_plugin-vue_export-helper.mjs";
function i(o, e, f, c, _, $) {
  const r = n("RadioGroup");
  return s(), a(r, {
    modelValue: o.modelProxy,
    "onUpdate:modelValue": e[0] || (e[0] = (l) => o.modelProxy = l),
    class: d(["inline-flex rounded-lg p-0.5", o.classes])
  }, {
    default: p(() => [
      m(o.$slots, "default")
    ]),
    _: 3
  }, 8, ["modelValue", "class"]);
}
const G = /* @__PURE__ */ u(t, [["render", i]]);
export {
  G as default
};
//# sourceMappingURL=SwitchButtonGroup.vue.mjs.map
